<template>
  <div class="my-2">
    <p class="font-weight-bolder mb-0">
      Início: {{ $moment(begin).format('DD/MM/YYYY HH:mm') }}
    </p>
    <p class="font-weight-bolder mb-0">
      Fim: {{ $moment(end).format('DD/MM/YYYY HH:mm') }}
    </p>
  </div>
</template>
<script>
    export default {
        props: {
            begin: {
                type: String,
                required:true,
            },
            end: {
                type: String,
                required:true,
            },
        },
    }
</script>
